import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { EXPRESION_RFC, DEFAULT_MASKS } from '../servicio/ServicioConstantes';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from '../servicio/ServicioHttp';
import { AltaRegistroPatronal } from './AltaRegistroPatronal';
import { FileUpload } from 'primereact/components/fileupload/FileUpload';
import ServicioArchivos from '../servicio/ServicioArchivos';
import { obtenerBytesBase64Archivos } from '../servicio/ServicioLecturaArchivos';
import { Archivo } from '../componentes/Archivo';
import { validacionCertificadosDigitales } from '../servicio/ServicioValidacionCertificadosDigitales';
import forge from 'node-forge';
const PATRON_INICIAL = {
}
const ERRORES_INICIAL = {
}
const PAGINACION_INICIAL = {
    registrosPorPagina: 10,
    registrosTotales: 0,
    join: null,
    restriccionesDinamicas: [
    ]
}
const VALOR_REQUERIDO = "Dato requerido";

const JOIN_PRINCIPAL = {
    "ttPatron": "alias_ttPatron"

};

export class AltaEmpresa extends Component {
    constructor() {

        super();
        this.state = {
            fracciones: [],
            listaPrimaRiesgo: [],
            datosSeleccionados: [],
            consulta: {},
            guardarId: {},
            objetoFecha: {},
            archivos: null,
            esPfx: false,
            esFiel: false,
            opcion: {},
            mostrarModalConfirmacionRegistro: false,
            mostrarModalCertificados: false,
            erroresCarga: {},
            patron: JSON.parse(JSON.stringify(PATRON_INICIAL)),
            errores: JSON.parse(JSON.stringify(ERRORES_INICIAL)),
            registroPatronal: JSON.parse(JSON.stringify(PATRON_INICIAL)),
            error: JSON.parse(JSON.stringify(ERRORES_INICIAL)),
            municipios: [],
            delegaciones: [],
            subdelegaciones: [],
            paginacion: PAGINACION_INICIAL,
            idsenube: 0,
            paginacionRegistrosPatronales: PAGINACION_INICIAL,
            mostrarModalConfirmacion: false,
            esEditar: false,
            verModalAltaRegistroPatronal: false,
            mostrarModalEditarRegistroPatronal: false,            
            opcionCertificados: [{ label: "FIEL", value: 0 }, { label: "Certificado Pfx", value: 1 }],
            areas: [
                { label: "Área - A", value: "ÁREA A" },
                { label: "Área - B", value: "ÁREA B" },
                { label: "Área - C", value: "ÁREA C" },
            ],
            meses: [
                { label: "Enero", value: "Enero" },
                { label: "Febrero", value: "Febrero" },
                { label: "Marzo", value: "Marzo" },
                { label: "Abril", value: "Abril" },
                { label: "Mayo", value: "Mayo" },
                { label: "Junio", value: "Junio" },
                { label: "Julio", value: "Julio" },
                { label: "Agosto", value: "Agosto" },
                { label: "Septiembre", value: "Septiembre" },
                { label: "Octubre", value: "Octubre" },
                { label: "Noviembre", value: "Noviembre" },
                { label: "Diciembre", value: "Diciembre" }
            ],
            anios: [
                { label: "1997", value: 1997 },
                { label: "1998", value: 1998 },
                { label: "1999", value: 1999 },
                { label: "2000", value: 2000 },
                { label: "2001", value: 2001 },
                { label: "2002", value: 2002 },
                { label: "2003", value: 2003 },
                { label: "2004", value: 2004 },
                { label: "2005", value: 2005 },
                { label: "2006", value: 2016 },
                { label: "2007", value: 2007 },
                { label: "2008", value: 2008 },
                { label: "2009", value: 2009 },
                { label: "2010", value: 2010 },
                { label: "2011", value: 2011 },
                { label: "2012", value: 2012 },
                { label: "2013", value: 2013 },
                { label: "2014", value: 2014 },
                { label: "2015", value: 2015 },
                { label: "2016", value: 2016 },
                { label: "2017", value: 2017 },
                { label: "2018", value: 2019 },
                { label: "2020", value: 2020 },
                { label: "2021", value: 2021 },
                { label: "2022", value: 2022 },
                { label: "2023", value: 2023 },
                { label: "2024", value: 2024 },
                { label: "2025", value: 2025 },
                { label: "2026", value: 2026 },
                { label: "2027", value: 2027 },
                { label: "2028", value: 2028 },
                { label: "2029", value: 2029 },
                { label: "2030", value: 2030 },
            ],
            clases: [
                { label: "I - Ordinario", value: "I" },
                { label: "II - Bajo", value: "II" },
                { label: "III - Medio", value: "III" },
                { label: "IV - Alto", value: "IV" },
                { label: "V - Máximo", value: "V" },
            ],
            stypss: [
                { label: "No", value: "No" },
                { label: "Si", value: "Si" }
            ],
        };

        this.obtenerPatrones();
    }
    cerrarModal = () => {
        this.setState({ mostrarModalEditarRegistroPatronal: false });
    }

    obtenerPatrones = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('/patron/paginacion.json', paginacion).then(response => {
            this.setState({
                paginacion: response.data.objeto
            });
        }).catch(error => {
        });
    }
    obtnerRegistrosPatronales = (id) => {
        let { paginacionRegistrosPatronales } = this.state;
        paginacionRegistrosPatronales.join = JOIN_PRINCIPAL;
        paginacionRegistrosPatronales.restriccionesDinamicas = [
            {
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttPatron.id",
                valorPropiedad: id
            }
        ];

        servicioHttp.consumirPostHttp('/registropatronal/paginacion.json', paginacionRegistrosPatronales).then(response => {
            this.setState({
                paginacionRegistrosPatronales: response.data.objeto
            });
        }).catch(error => {
        });
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
    }

    asignarValores = (event, mayusculas) => {
        let { opcion, registroPatronal } = this.state;
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
        let id = event.target.id;
        let valor = event.target.value;
        let valores = event.target.value.value;
        if (id === "patron.codigoPostal") {
            let { patron } = this.state;
            this.obtenerEntidad(valor, patron);
        }
        if (id === "opcion.valor") {
            if (opcion.valor.value === 0) {
                this.setState({ esFiel: true, esPfx: false });
            }
            if (opcion.valor.value === 1) {
                this.setState({ esPfx: true, esFiel: false });
            }
        }
        if (id === "registroPatronal.codigoPostal") {
            this.consultarEntidad(valor, registroPatronal);
            this.consultarDelegacion(valor, registroPatronal);
        }
        if (id === "registroPatronal.delegacion") {
            registroPatronal.claveSubdelegacion = null;
            this.consultarDelegacion(valores, registroPatronal);
            this.consultarSubdelegacion(valores, registroPatronal);
        }
        if (id === "registroPatronal.subdelegacion") {
            this.consultarClaveSubdelegacion(valores, registroPatronal);
        }
        if (id === "registroPatronal.clase") {
            let valores = null;
            this.cargarFraccion(valores);
        }
    };

    obtenerEntidad = (codigoPostal, patron) => {
        if (codigoPostal.length >= 2) {
            let valor = codigoPostal.substring(0, 2);
            servicioHttp.consumirPostHttp("/claveentidad/obtener_cp.json", { codigoPostalAsentamiento: valor }).then(response => {
                let claveEntidad = response.data.objeto;
                patron.entidad = claveEntidad.claveEstado + " " + claveEntidad.estado;
                this.obtenerMunicipios(claveEntidad.claveEstado).then(response => {
                    this.setState({
                        municipios: response.data.lista
                    });
                    if (servicioObjetos.esObjetoVacio(patron.id)) {
                        patron.poblacion = null;
                    } else {
                        let valorPoblacion = patron.poblacion;
                        patron.poblacion = { value: valorPoblacion, label: valorPoblacion }
                    }
                    this.setState({ patron: patron });
                }).catch(error => {

                });
            }).catch(error => {

            });
        } else {
            patron.entidad = null;
            patron.poblacion = null;
            this.setState({
                patron: patron,
                municipios: []
            });
        }
    }
    consultarEntidad = (codigoPostal, registroPatronal) => {
        if (codigoPostal.length >= 2) {
            let valor = codigoPostal.substring(0, 2);
            servicioHttp.consumirPostHttp("/claveentidad/obtener_cp.json", { codigoPostalAsentamiento: valor }).then(response => {
                let claveEntidad = response.data.objeto;
                registroPatronal.entidad = claveEntidad.claveEstado + " " + claveEntidad.estado;
                this.obtenerMunicipios(claveEntidad.claveEstado).then(responseMunicipios => {
                    if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
                        registroPatronal.poblacion = null;
                    } else {
                        let valorPoblacion = registroPatronal.poblacion;
                        registroPatronal.poblacion = { value: valorPoblacion, label: valorPoblacion }
                    }

                    this.setState({
                        registroPatronal: registroPatronal,
                        municipios: responseMunicipios.data.lista
                    });
                }).catch(error => {

                });
            }).catch(error => {

            });
        } else {
            registroPatronal.entidad = null;
            registroPatronal.poblacion = null;
            this.setState({
                registroPatronal: registroPatronal,
                municipios: []
            });
        }
    }

    obtenerEntidadRegistroPatronal = (codigoPostal, registroPatronal) => {
        if (codigoPostal.length >= 2) {
            let valor = codigoPostal.substring(0, 2);
            servicioHttp.consumirPostHttp("/claveentidad/obtener_cp.json", { codigoPostalAsentamiento: valor }).then(response => {
                let claveEntidad = response.data.objeto;
                registroPatronal.entidad = claveEntidad.claveEstado + " " + claveEntidad.estado;
                this.obtenerMunicipios(claveEntidad.claveEstado).then(response => {
                    this.setState({
                        municipios: response.data.lista
                    });
                    if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
                        registroPatronal.poblacion = null;
                    } else {
                        let valorPoblacion = registroPatronal.poblacion;
                        registroPatronal.poblacion = { value: valorPoblacion, label: valorPoblacion }
                    }
                    this.setState({ registroPatronal: registroPatronal });
                }).catch(error => {

                });
            }).catch(error => {

            });
        } else {
            registroPatronal.entidad = null;
            registroPatronal.poblacion = null;
            this.setState({
                registroPatronal: registroPatronal,
                municipios: []
            });
        }
    }
    consultarDelegacion = (codigoPostal, registroPatronal) => {
        if (codigoPostal.length >= 2) {
            let valor = codigoPostal.substring(0, 2);
            servicioHttp.consumirPostHttp("/claveentidad/obtener_cp.json", { codigoPostalAsentamiento: valor }).then(response => {
                let claveEntidad = response.data.objeto;
                this.obtenerDelegacion(claveEntidad.claveEstado).then(responseDelegaciones => {
                    this.setState({ delegaciones: responseDelegaciones.data.lista });
                    if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
                        registroPatronal.delegacion = null;
                    } else {
                        let valorDelegacion = registroPatronal.delegacion;
                        registroPatronal.delegacion = { value: valorDelegacion, label: valorDelegacion }
                    }
                    this.setState({ registroPatronal: registroPatronal });
                }).catch(error => {
                });
            }).catch(error => {

            });
        } else {
            registroPatronal.delegacion = null;
            this.setState({
                registroPatronal: registroPatronal,
                delegaciones: []
            });
        }
    }
    obtenerDelegacion = (claveEstado) => {
        return new Promise(function (resolve, reject) {
            servicioHttp.consumirPostHttp('delegaciones/obtener_delegaciones.json', { claveEstado: claveEstado }).then(response => {
                resolve(response);
            }).catch(error => {
                reject("error");
            });
        });
    }
    consultarSubdelegacion = (delegacion, registroPatronal) => {
        let valor = delegacion;
        servicioHttp.consumirPostHttp('delegaciones/consulta_subdelegaciones.json', { delegacion: valor }).then(response => {
            this.setState({ subdelegaciones: response.data.lista });
            if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
                registroPatronal.subdelegacion = null;
            } else {
                let valorSubdelegacion = registroPatronal.subdelegacion;
                registroPatronal.subdelegacion = { value: valorSubdelegacion, label: valorSubdelegacion }
            }
            this.setState({ registroPatronal: registroPatronal });
        }).catch(error => {
        });
    }

    /**
     * Método que permite obtener la clave de la subdelegación y poder llebar el campo clave subdelegación,
     * en base a la subdelegación seleccionada.
     * @param {*} subdelegacion 
     * @param {*} registroPatronal 
     */
    consultarClaveSubdelegacion = (subdelegacion, registroPatronal) => {
        let valor = subdelegacion;
        servicioHttp.consumirPostHttp("delegaciones/obtener_clave.json", { subdelegacion: valor }).then(response => {
            let clave = response.data.objeto;
            registroPatronal.claveSubdelegacion = clave.claveSubdelegacion;
            this.setState({ registroPatronal: registroPatronal });
        }).catch(error => {

        });
    }


    obtenerMunicipios = (claveEstado) => {
        return new Promise(function (resolve, reject) {
            servicioHttp.consumirPostHttp('/municipioalcaldia/obtener_estado.json', { claveEstado: claveEstado }).then(response => {
                resolve(response);
            }).catch(error => {
                reject("error");
            });
        });
    }

    guardarPatron = () => {
        let { patron } = this.state;
        let patronEnvio = JSON.parse(JSON.stringify(patron));
        let errores = this.validarFormulario(patronEnvio);
        this.setState({ errores: errores });
        if (servicioObjetos.esObjetoVacio(errores)) {
            let poblacion = patronEnvio.poblacion;
            patronEnvio.poblacion = null;
            patronEnvio.poblacion = poblacion.value;
            servicioHttp.consumirPostHttp('/patron/guardar.json', patronEnvio).then(response => {
                this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
                this.btnLimpiar();
                this.obtenerPatrones();
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'Existe un error no esperado la guardar el patrón' });
            });
        }
    }

    validarFormulario = (patron) => {
        let errores = JSON.parse(JSON.stringify(ERRORES_INICIAL));
        if (servicioObjetos.esObjetoVacio(patron.rfc)) {
            errores.rfc = VALOR_REQUERIDO;
        } else {
            let patronRfc = EXPRESION_RFC;
            let validacionRFC = patronRfc.exec(patron.rfc);
            if (!validacionRFC)
                errores.rfc = "Estructura inválida del RFC";
        }

        if (servicioObjetos.esObjetoVacio(patron.nombre))
            errores.nombre = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(patron.nombreComercial))
            errores.nombreComercial = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(patron.calle))
            errores.calle = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(patron.codigoPostal)) {
            errores.codigoPostal = VALOR_REQUERIDO;
        } else {
            if (patron.codigoPostal.length !== 5)
                errores.codigoPostal = "La longitud del código postal debe de ser de 5 carácteres";
        }

        if (servicioObjetos.esObjetoVacio(patron.entidad))
            errores.entidad = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(patron.poblacion))
            errores.poblacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(patron.actividadEconomica))
            errores.actividadEconomica = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(patron.nombreRepresentanteLegal))
            errores.nombreRepresentanteLegal = VALOR_REQUERIDO;

        if (servicioObjetos.esObjetoVacio(patron.rfcRepresentanteLegal)) {
            errores.rfcRepresentanteLegal = VALOR_REQUERIDO;
        } else {
            let representanteRfc = EXPRESION_RFC;
            let validacionRFC = representanteRfc.exec(patron.rfcRepresentanteLegal);
            if (!validacionRFC)
                errores.rfcRepresentanteLegal = "Estructura inválida del RFC";
        }

        if (servicioObjetos.esObjetoVacio(patron.curpRepresentanteLegal)) {
            errores.curpRepresentanteLegal = VALOR_REQUERIDO;
        } else {
            if (patron.curpRepresentanteLegal.length !== 18)
                errores.curpRepresentanteLegal = "La longitud del CURP debe de ser de 18 carácteres";
        }

        return errores;
    }

    btnLimpiar = () => {
        this.setState({
            patron: JSON.parse(JSON.stringify(PATRON_INICIAL)),
            errores: JSON.parse(JSON.stringify(ERRORES_INICIAL)),
            municipios: [],
            esEditar: false
        });
    }

    btnMostrar = () => {
        this.setState({
            patron: JSON.parse(JSON.stringify(PATRON_INICIAL)),
            errores: JSON.parse(JSON.stringify(ERRORES_INICIAL)),
            municipios: [],
            esEditar: false
        });

    }

    onIndexTemplate = (data, props) => {
        let { idsenube } = this.state;
        return (props.rowIndex + 1) + idsenube;
    }

    prepararEditar = (rowData) => {
        let { guardarId } = this.state;
        let patron = JSON.parse(JSON.stringify(rowData));
        this.obtenerEntidad(rowData.codigoPostal, patron);
        this.setState({
            esEditar: true
        });
        guardarId.id = rowData.id;
        this.setState({ guardarId });
        this.obtnerRegistrosPatronales(rowData.id);
    }

    preditarRegistro = (rowData) => {
        servicioHttp.consumirPostHttp('registropatronal/listado_prima_riesgo_trabajo.json', { id: rowData.id }).then(response => {
            let registroPatronal = JSON.parse(JSON.stringify(rowData));
            this.obtenerEntidadRegistroPatronal(rowData.codigoPostal, registroPatronal);
            this.consultarDelegacion(rowData.codigoPostal, registroPatronal);
            this.consultarSubdelegacion(rowData.delegacion, registroPatronal);
            this.cargarFraccion(registroPatronal.clase);


            this.setState({ listaPrimaRiesgo: response.data.lista, registroPatronal: registroPatronal, mostrarModalEditarRegistroPatronal: true });
        }).catch(error => {
        })
    }
    cargarFraccion = (clase) => {
        let valor = clase;
        servicioHttp.consumirPostHttp("fraccion/consultar_fracciones.json", { clase: valor }).then(response => {
            this.setState({ fracciones: response.data.lista });
        }).catch(error => {
        });
    }

    mostrarModalEliminar = (rowData) => {
        this.setState({ mostrarModalConfirmacion: true, patronEliminar: rowData });
    }

    cerrarModalConfirmacion = () => {
        this.setState({ mostrarModalConfirmacion: false });
    }
    plantillaOpcionesRegistroPatronal = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-edit"
                    className="p-button-warning" name="Editar" onClick={(e) => this.preditarRegistro(rowData)} tooltip="Editar">
                </Button>
            </div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-delete"
                    className="p-button-danger" name="Eliminar" onClick={(e) => this.mostrarEliminarRegistroPatronal(rowData)} tooltip="Eliminar" >
                </Button>
            </div>
            <div className="p-col-12 p-md-4">
                <Button
                    type="button"
                    icon="pi-md-save"
                    onClick={(e) => this.verModalCertificados(column.rowData)}
                    className="p-button-success"
                    name="cargar certificado"
                    tooltip="Cargar certificado" >
                </Button>
            </div>

        </div>;
    }
    mostrarEliminarRegistroPatronal = (objeto) => {
        let { registroPatronal } = this.state;
        registroPatronal.id = objeto.id;
        this.setState({ mostrarModalConfirmacionRegistro: true, registroPatronal });

    }
    eliminarRegistroPatronal = () => {
        let { registroPatronal } = this.state;
        servicioHttp.consumirPostHttp('registropatronal/eliminar.json', registroPatronal).then(response => {
            this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
            this.resetEstados();
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: 'Existe un error no esperado la guardar el patrón' });
        });
    }
    editarRegistroPatronal = () => {
    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.prepararEditar(rowData)}
                    className="p-button-warning" name="Editar" tooltip="Editar">
                </Button>
            </div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(rowData)}
                    className="p-button-danger" name="Eliminar" tooltip="Eliminar" >
                </Button>
            </div>


        </div>;
    }

    eliminarPatron = () => {
        let { patronEliminar } = this.state;
        servicioHttp.consumirPostHttp('/patron/eliminar.json', patronEliminar).then(response => {
            this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
            this.cerrarModalConfirmacion();
            this.obtenerPatrones();
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: 'Existe un error no esperado la eliminar el patrón' });
            this.cerrarModalConfirmacion();
        });
    }

    /**
     * Método que permite abrir el Modal para el registro de un nuevo Registro Patronal
     */
    mostrarModalAltaRegistroPatronal = () => {
        this.setState({ verModalAltaRegistroPatronal: true });
    };

    /**
     * Método que permite cerrar el Modal Alta de Registro Patronal
     */
    cerrarModalAltaRegistroPatronal = () => {
        this.setState({ verModalAltaRegistroPatronal: false });
    }

    guardarRegistro = (response) => {
        this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
        this.cerrarModalAltaRegistroPatronal();
    }
    columnaEstatus = (objeto) => {
        if (objeto.estado === 0)
            return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
        if (objeto.estado === 1)
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Inactivo</p>;

    }

    resetEstados = () => {
        this.setState({ mostrarModalEditarRegistroPatronal: false, esFiel: false, esPfx: false, registroPatronal: {}, erroresCarga: {}, opcion: {}, mostrarModalConfirmacionRegistro: false, mostrarModalCertificados: false, mostrarModalConfirmacion: false });
    }
    verModalCertificados = (objeto) => {
        let { registroPatronal } = this.state;
        registroPatronal.id = objeto.id;
        this.setState({ mostrarModalCertificados: true });
    }
    onUpload = (event) => {        
        let objeto = {}
        ServicioArchivos.obtenerBytesBase64StringArchivoPromise(event.files[0], objeto, 'archivo').then(response => {
            this.setState({ archivos: objeto });
        });
    }
    cargarArchivo = (event) => {
        obtenerBytesBase64Archivos(event, this);
    }
    guardarCargaCertificado = () => {
        let { archivos, registroPatronal, esFiel, esPfx, patron } = this.state;
        console.log(patron.rfc);
        if (esPfx) {
            if (!servicioObjetos.esObjetoVacio(archivos)) {
                registroPatronal.certificadoPfx = archivos.archivo;
            }

        }

        let errores = this.validarFormularioCarga(registroPatronal);
        this.setState({ erroresCarga: errores });
        if (servicioObjetos.esObjetoVacio(errores)) {
            let validacionPfx = [];
            if (esPfx) {
                registroPatronal.certificadoCer = null;
                registroPatronal.certificadoKey = null;
                registroPatronal.contraseniaFiel = null;
                validacionPfx = this.validarCertificadoPfx(registroPatronal);
            }


            if (!Object.keys(validacionPfx).length) {
                try {
                    if (esFiel) {
                        registroPatronal.certificadoPfx = null;
                        registroPatronal.contraseniaPfx = null;
                        validacionCertificadosDigitales(registroPatronal.certificadoCer, registroPatronal.certificadoKey, registroPatronal.contraseniaFiel, patron.rfc, "FIEL");
                    }
                    servicioHttp.consumirPostHttp('registropatronal/actualizar_certificados.json', registroPatronal).then(response => {
                        this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
                        this.resetEstados();
                    }).catch(error => {
                        this.growl.show({ severity: 'error', summary: 'Error', detail: 'Existe un error no esperado la eliminar el patrón' });
                        this.resetEstados();
                    });
                } catch (error) {
                    var cadena = error;
                    var mensaje = cadena.toString();
                    this.growl.show({ severity: 'error', summary: 'Error', detail: mensaje, life: 10000 });
                }

            }

        }
    }
    validarFormularioCarga = (objeto) => {
        let { esPfx, esFiel } = this.state;
        const errores = {};
        if (esPfx) {
            if (servicioObjetos.esObjetoVacio(objeto.usuario))
                errores.usuario = "Campo requerido";
            if (servicioObjetos.esObjetoVacio(objeto.contraseniaPfx))
                errores.contrasena = "Campo requerido";
            if (servicioObjetos.esObjetoVacio(objeto.certificadoPfx))
                errores.certificadoPfx = "Campo requerido";
        }

        if (esFiel) {
            if (servicioObjetos.esObjetoVacio(objeto.usuario))
                errores.usuario = "Campo requerido";
            if (servicioObjetos.esObjetoVacio(objeto.certificadoCer))
                errores.certificadoCer = "Campo requerido";
            if (servicioObjetos.esObjetoVacio(objeto.certificadoKey))
                errores.certificadoKey = "Campo requerido";
            if (servicioObjetos.esObjetoVacio(objeto.contraseniaFiel))
                errores.contraseniaFiel = "Campo requerido";

        }


        return errores;
    }

    validarFormularioActualizar = (registroPatronal) => {
        let error = {};
        if (servicioObjetos.esObjetoVacio(registroPatronal.codigoPostal)) {
            error.codigoPostal = "valor requerido";
        } else {
            if (registroPatronal.codigoPostal.length !== 5)
                error.codigoPostal = "La longitud del código postal debe de ser de 5 carácteres";
        }
        if (servicioObjetos.esObjetoVacio(registroPatronal.areaGeografica))
            error.area = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.entidad))
            error.entidad = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.poblacion))
            error.poblacion = "valor requerido";
        if (typeof registroPatronal.poblacion.value === "object")
            error.poblacion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.delegacion))
            error.delegacion = "valor requerido";
        if (typeof registroPatronal.delegacion.value === "object")
            error.delegacion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.claveSubdelegacion))
            error.claveSubdelegacion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.subdelegacion))
            error.subdelegacion = "valor requerido";
        if (typeof registroPatronal.subdelegacion.value === "object")
            error.subdelegacion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.clase))
            error.clase = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.fraccion))
            error.fraccion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.styps))
            error.styps = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.telefono))
            error.telefono = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.actividadEconomica))
            error.actividadEconomica = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.representanteLegal))
            error.representanteLegal = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.calle))
            error.calle = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.mesAfiliacion))
            error.mesAfiliacion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.anioAfiliacion))
            error.anioAfiliacion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.clase))
            error.clase = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.fraccion))
            error.fraccion = "valor requerido";
        if (servicioObjetos.esObjetoVacio(registroPatronal.registroPatronal))
            error.registroPatronal = "valor requerido";

        return error;
    }

    actualizarRegistroPatronal = () => {
        let { registroPatronal, guardarId } = this.state;

        let error = this.validarFormularioActualizar(registroPatronal);
        this.setState({ error: error });
        if (servicioObjetos.esObjetoVacio(error)) {
            registroPatronal.poblacion = registroPatronal.poblacion.value;
            registroPatronal.delegacion = registroPatronal.delegacion.value;
            registroPatronal.subdelegacion = registroPatronal.subdelegacion.value;


            servicioHttp.consumirPostHttp('registropatronal/actualizar_registro_patronal.json', registroPatronal).then(response => {
                this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
                this.obtnerRegistrosPatronales(guardarId.id);
                this.resetEstados();
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'Existe un error no esperado al actualizar el registro Patronal' });
                this.resetEstados();
            });
        }
    }

    validarCertificadoPfx = (objetoEmpresa) => {
        let { archivos, objetoFecha } = this.state;
        const errores = {};
        var p12Der = forge.util.decode64(archivos.archivo);
        var p12Asn1 = forge.asn1.fromDer(p12Der);
        let p12 = null;
        try {
            p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, objetoEmpresa.contraseniaPfx);
            var bags = p12.getBags({ bagType: forge.pki.oids.certBag });
            var certificado2 = bags[forge.pki.oids.certBag][1];
            objetoFecha.fecha = certificado2.cert.validity.notAfter;
            this.setState({ objetoFecha });
        } catch (e) {
            console.log("La contraseña del archivo es incorrecta");
            errores.contrasena = "La contraseña del archivo .pfx es incorrecta";
            this.growl.show({ severity: 'error', summary: 'Error', detail: errores.contrasena, life: 10000 });
        }

        return errores;


    }
    buscarPatron = () => {

        let { paginacion, consulta } = this.state;

        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(consulta.rfc)) {
            paginacion.restriccionesDinamicas.push({

                tipoRestriccion: "like",
                modoLike: "START",
                nombrePropiedad: "rfc",
                valorPropiedad: consulta.rfc
            });
        }
        if (!servicioObjetos.esObjetoVacio(consulta.nombreComercial)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "like",
                modoLike: "START",
                nombrePropiedad: "nombreComercial",
                valorPropiedad: consulta.nombreComercial
            });
        }

        servicioHttp.consumirPostHttp('/patron/paginacion.json', paginacion).then(response => {
            this.setState({
                paginacion: response.data.objeto
            });
        }).catch(error => {
        });

    }

    limpiarBusqueda = () => {
        this.setState({ consulta: {} });
    }

    agregarPrimaRiesgoTrabajo = () => {
        let error = {};
        let { registroPatronal, listaPrimaRiesgo } = this.state;
        if (servicioObjetos.esObjetoVacio(registroPatronal.meses) ||
            servicioObjetos.esObjetoVacio(registroPatronal.anios) ||
            servicioObjetos.esObjetoVacio(registroPatronal.prima)) {
            error.meses = "Seleccione Mes";
            error.anios = "Seleccione Año";
            error.prima = "Proporcione Prima";
        } else {
            let mensajeValidacion = "El formato es invalido debe de ser 0.00000";
            var primaValido = /^(\d{1})(.)(\d{5})$/;
            var validacionPrima = primaValido.exec(registroPatronal.prima);
            if (!validacionPrima) {
                error.prima = mensajeValidacion;
            }
            if (servicioObjetos.esObjetoVacio(error)) {
                let primaRiesgo = {
                    mes: registroPatronal.meses,
                    anio: registroPatronal.anios,
                    prima: registroPatronal.prima
                };
                delete registroPatronal.meses;
                delete registroPatronal.anios;
                delete registroPatronal.prima;
                listaPrimaRiesgo.push(primaRiesgo);
                let ttRegistroPatronal = {};
                ttRegistroPatronal.id = registroPatronal.id;
                primaRiesgo.ttRegistroPatronal = ttRegistroPatronal;
                servicioHttp.consumirPostHttp('prima/guardar.json', primaRiesgo).then(response => {
                    this.setState({
                        listaPrimaRiesgo: listaPrimaRiesgo,
                        registroPatronal: registroPatronal
                    });
                }).catch(error => {
                });
            }

        }
        this.setState({ error: error });
    }
    plantillaChecBoxDatos = (rowData, column) => {
        return <Checkbox inputId="cb2" value={rowData} onChange={this.validarRegistrosDatos} checked={this.state.datosSeleccionados.indexOf(rowData) !== -1} ></Checkbox>
    }
    validarRegistrosDatos = (e) => {
        let { datosSeleccionados } = this.state;
        if (e.checked) {
            datosSeleccionados.push(e.value);
        } else {
            servicioObjetos.eliminarObjetoMapa(datosSeleccionados, e.value);
        }
        this.setState({ datosSeleccionados: datosSeleccionados });
    }
    eliminarDelaListaCaptura = () => {
        let { listaPrimaRiesgo, datosSeleccionados } = this.state;
        let copiaSeleccionados = [...datosSeleccionados];
        for (let contador = 0; contador < copiaSeleccionados.length; contador++) {
            let elemento = copiaSeleccionados[contador];
            let primaRiesgo = {};
            primaRiesgo.id = elemento.id;
            servicioObjetos.eliminarObjetoMapa(listaPrimaRiesgo, elemento);
            servicioObjetos.eliminarObjetoMapa(datosSeleccionados, elemento);
            servicioHttp.consumirPostHttp('prima/eliminar.json', primaRiesgo).then(response => {




            }).catch(error => {
            })

        }
        this.setState({
            listaPrimaRiesgo: listaPrimaRiesgo,
            datosSeleccionados: datosSeleccionados
        });
        this.growl.show({ severity: 'success', summary: 'Aviso', detail: "Prima eliminada de la tabla con éxito", life: 20000 });
    }



    render() {
        const { stypss, fracciones, listaPrimaRiesgo, datosSeleccionados, consulta, esPfx, esFiel, opcion, opcionCertificados, mostrarModalConfirmacionRegistro, erroresCarga, delegaciones, subdelegaciones, areas, meses, anios, clases, registroPatronal, mostrarModalEditarRegistroPatronal, error, paginacionRegistrosPatronales, patron, errores, municipios, paginacion, idsenube, mostrarModalConfirmacion,
            esEditar, verModalAltaRegistroPatronal } = this.state;

        const pieDialogoDetalle = (
            <div>
                <Button icon="pi-md-check" label="Aceptar" onClick={this.actualizarRegistroPatronal} />
                <Button icon="pi-md-close" label="Cancelar" onClick={this.resetEstados} className="p-button-danger flat-btn" />
            </div>
        );

        const dialogFooterConfirmacionEliminar = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.eliminarPatron}
                    label="Si estoy seguro" />
                <Button
                    icon="pi-md-close"
                    onClick={this.cerrarModalConfirmacion}
                    label="No estoy seguro"
                    className="p-button-danger flat-btn" />
            </div>
        );
        const dialogFooterConfirmacionEliminarRegistroPatronal = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.eliminarRegistroPatronal}
                    label="Si estoy seguro" />
                <Button
                    icon="pi-md-close"
                    onClick={this.resetEstados}
                    label="No estoy seguro"
                    className="p-button-danger flat-btn" />
            </div>
        );
        const pieDialogoCertificado = <div className="ui-dialog-buttonpane p-clearfix">

            <Button
                label="Guardar"
                icon="pi-md-save"
                onClick={this.guardarCargaCertificado}
            />

            <Button
                label="Cancelar"
                icon="pi-md-close"
                onClick={this.resetEstados.bind(this)}
                className="p-button-danger " />
        </div>;

        return (<div>
            <Growl ref={(el) => this.growl = el} />
            <div className="card">
                <h1>Patrón nuevo</h1>
                <p>En esta sección usted puede dar de alta nuevos patrones</p>
            </div>

            <div className="card card-w-title">
                <div className="p-grid">
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.rfc">* RFC:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.rfc" name="patron.rfc" placeholder="RFC" style={{ width: "100%" }}
                            value={patron.rfc || ""} className={errores.rfc ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="13" keyfilter={DEFAULT_MASKS.alphanum} type="search" />
                        {errores.rfc ? <div><Message severity="error" text={errores.rfc} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.nombre">* Nombre de Nominación/Razón Social:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.nombre" name="patron.nombre" placeholder="Nombre" style={{ width: "100%" }}
                            value={patron.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="100" type="search" />
                        {errores.nombre ? <div><Message severity="error" text={errores.nombre} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.nombreComercial">* Nombre Comercial:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.nombreComercial" name="patron.nombreComercial" placeholder="Nombre Comercial" style={{ width: "100%" }}
                            value={patron.nombreComercial || ""} className={errores.nombreComercial ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="25" type="search" />
                        {errores.nombreComercial ? <div><Message severity="error" text={errores.nombreComercial} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.calle">* Calle, No. y Colonia:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.calle" name="patron.calle" placeholder="Calle, No. y Colonia" style={{ width: "100%" }}
                            value={patron.calle || ""} className={errores.calle ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="100" type="search" />
                        {errores.calle ? <div><Message severity="error" text={errores.calle} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.codigoPostal">* Código Postal:</label>
                    </div>
                    <div className="p-col-12 p-md-3" >
                        <InputText id="patron.codigoPostal" name="patron.codigoPostal" placeholder="Código postal" style={{ width: "100%" }}
                            value={patron.codigoPostal || ""} className={errores.codigoPostal ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="5" keyfilter="pint" type="search" />
                        {errores.codigoPostal ? <div><Message severity="error" text={errores.codigoPostal} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.entidad">* Entidad:</label>
                    </div>
                    <div className="p-col-12 p-md-3" >
                        <InputText id="patron.entidad" name="patron.entidad" placeholder="Entidad" style={{ width: "100%", 'font-weight': 'bold', color: 'blue' }}
                            value={patron.entidad || ""} className={errores.entidad ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            disabled={true} />
                        {errores.entidad ? <div><Message severity="error" text={errores.entidad} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.poblacion">* Población y Municipio/Alcaldía:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <Dropdown appendTo={document.body} id="patron.poblacion" name="patron.poblacion" optionLabel="label" options={municipios} value={patron.poblacion}
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={errores.poblacion ? "p-error" : ""}
                            placeholder="Seleccione población" />
                        {errores.poblacion ? <div><Message severity="error" text={errores.poblacion} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.telefono">Teléfono:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.telefono" name="patron.telefono" placeholder="Teléfono" style={{ width: "100%" }}
                            value={patron.telefono || ""} className={errores.telefono ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="10" keyfilter="pint" type="search" />
                        {errores.telefono ? <div><Message severity="error" text={errores.telefono} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.actividadEconomica">* Actividad Económica:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.actividadEconomica" name="patron.actividadEconomica" placeholder="Actividad Económica" style={{ width: "100%" }}
                            value={patron.actividadEconomica || ""} className={errores.actividadEconomica ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="100" keyfilter={DEFAULT_MASKS.alphaspace} type="search" />
                        {errores.actividadEconomica ? <div><Message severity="error" text={errores.actividadEconomica} /></div> : null}
                    </div>
                </div>
                <h1>Datos del patrón o representante legal</h1>
                <div className="p-grid">
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.nombreRepresentanteLegal">* Nombre del patrón o representante legal:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.nombreRepresentanteLegal" name="patron.nombreRepresentanteLegal" placeholder="Nombre Representante Legal" style={{ width: "100%" }}
                            value={patron.nombreRepresentanteLegal || ""} className={errores.nombreRepresentanteLegal ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="100" keyfilter={DEFAULT_MASKS.alphaspace} type="search" />
                        {errores.nombreRepresentanteLegal ? <div><Message severity="error" text={errores.nombreRepresentanteLegal} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.rfcRepresentanteLegal">* RFC:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.rfcRepresentanteLegal" name="patron.rfcRepresentanteLegal" placeholder="RFC Representante Legal" style={{ width: "100%" }}
                            value={patron.rfcRepresentanteLegal || ""} className={errores.rfcRepresentanteLegal ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="13" keyfilter={DEFAULT_MASKS.alphanum} type="search" />
                        {errores.rfcRepresentanteLegal ? <div><Message severity="error" text={errores.rfcRepresentanteLegal} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="patron.curpRepresentanteLegal">* CURP:</label>
                    </div>
                    <div className="p-col-12 p-md-9" >
                        <InputText id="patron.curpRepresentanteLegal" name="patron.curpRepresentanteLegal" placeholder="CURP Representante Legal" style={{ width: "100%" }}
                            value={patron.curpRepresentanteLegal || ""} className={errores.curpRepresentanteLegal ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="18" keyfilter={DEFAULT_MASKS.alphanum} type="search" />
                        {errores.curpRepresentanteLegal ? <div><Message severity="error" text={errores.curpRepresentanteLegal} /></div> : null}
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="p-grid">
                    <div className="p-col-12 p-md-4">
                        <Button label="Agregar Registro Patronal" icon="pi-md-plus" onClick={this.mostrarModalAltaRegistroPatronal} style={{ width: "100%" }} />
                    </div>
                    <div className="p-col-12 p-md-4">
                        <label></label>
                    </div>
                    {esEditar ?
                        <div className="p-col-12 p-md-2">
                            <Button label="Mostrar Patrones" icon="pi-md-refresh" onClick={this.btnMostrar} style={{ width: "100%" }} />
                        </div>
                        : null}
                    <div className="p-col-12 p-md-2">
                        <Button label="Limpiar" icon="pi-md-refresh" onClick={this.btnLimpiar} style={{ width: "100%" }} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label={esEditar ? 'Editar' : 'Guardar'} icon={esEditar ? 'pi-md-edit' : 'pi-md-save'} onClick={this.guardarPatron} style={{ width: "100%" }} />
                    </div>
                </div>
            </div>
            <div className="card">
                {!esEditar ?
                    <div className="p-grid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="consulta.criterio">Criterio de búsqueda</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.rfc">RFC:</label>
                        </div>
                        <div className="p-col-12 p-md-3" >
                            <InputText id="consulta.rfc" name="consulta.rfc" onKeyUp={this.buscarPatron} placeholder="RFC" style={{ width: "100%" }}
                                value={consulta.rfc || ""} className={errores.rfc ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                                maxLength="13" keyfilter={DEFAULT_MASKS.alphanum} type="search" />
                            {errores.rfc ? <div><Message severity="error" text={errores.rfc} /></div> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.rfc">Nombre Comercial:</label>
                        </div>
                        <div className="p-col-12 p-md-3" >
                            <InputText id="consulta.nombreComercial" onKeyUp={this.buscarPatron} name="consulta.nombreComercial" placeholder="Nombre Comercial" style={{ width: "100%" }}
                                value={consulta.nombreComercial || ""} className={errores.nombreComercial ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                                type="search" />
                            {errores.nombreComercial ? <div><Message severity="error" text={errores.nombreComercial} /></div> : null}
                        </div>
                       
                        <div className="p-col-12 p-md-2" >
                            <Button type="button" label="Buscar" icon="pi-md-search" onClick={this.buscarPatron} tooltip="Buscar" >
                            </Button>
                        </div>
                        <div className="p-col-12 p-md-2" >
                            <Button type="button" label="Limpiar" icon="pi-md-refresh" onClick={this.limpiarBusqueda} tooltip="Limpiar" >
                            </Button>

                        </div>
                    </div>
                    : null}

                {!esEditar ?

                    <DataTable value={paginacion.datos} header="Mis patrones" responsive={true} resizableColumns={true} autoLayout={true} >
                        <Column field="Index" header="Número" body={this.onIndexTemplate} style={{ width: '100px' }} />
                        <Column field="rfc" header="RFC" style={{ width: '100px' }} />
                        <Column field="nombre" header="Nombre de Nominación/Razón Social" style={{ width: '120px' }} />
                        <Column field="nombreComercial" header="Nombre Comercial" style={{ width: '150px' }} />
                        <Column field="calle" header="Calle, No. y Colonia" style={{ width: '150px' }} />
                        <Column field="codigoPostal" header="Código Postal" style={{ width: '200px' }} />
                        <Column field="entidad" header="Entidad" style={{ width: '200px' }} />
                        <Column field="poblacion" header="Población y Municipio/Alcaldía" style={{ width: '250px' }} />
                        <Column field="telefono" header="Teléfono" style={{ width: '150px' }} />
                        <Column field="actividadEconomica" header="Tipo de jornada" style={{ width: '150px' }} />
                        <Column field="rfcRepresentanteLegal" header="RFC Representante Legal" style={{ width: '150px' }} />
                        <Column field="nombreRepresentanteLegal" header="Nombre del patrón o representante legal" style={{ width: '150px' }} />
                        <Column field="curpRepresentanteLegal" header="CURP Representante Legal" style={{ width: '150px' }} />
                        <Column body={this.plantillaOpciones} header="Opciones" />
                    </DataTable>
                    : null}
                {esEditar ?

                    <DataTable value={paginacionRegistrosPatronales.datos} header="Registros Patronales" responsive={true} resizableColumns={true} autoLayout={true} >
                        <Column field="Index" header="Número" body={this.onIndexTemplate} style={{ width: '100px' }} />
                        <Column field="rfc" header="RFC" style={{ width: '100px' }} />
                        <Column field="registroPatronal" header="Registro Patronal" style={{ width: '100px' }} />
                        <Column body={this.columnaEstatus} header="Estatus" style={{ width: '100px' }} />
                        <Column body={this.plantillaOpcionesRegistroPatronal} header="Opciones" />
                    </DataTable>
                    : null}
                <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate={"Total: " + paginacion.registrosTotales + ", Página ({currentPage} de {totalPages})"} />
            </div>
            <Dialog
                header="Confirmación"
                visible={mostrarModalConfirmacion}
                modal={true}
                appendTo={document.body}
                footer={dialogFooterConfirmacionEliminar}
                onHide={this.cerrarModalConfirmacion}>
                <h2>¿Estás seguro de eliminar el patrón?</h2>
            </Dialog>

            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalAltaRegistroPatronal} onHide={this.cerrarModalAltaRegistroPatronal.bind(this)} modal={true} >
                <AltaRegistroPatronal guardarRegistroPatronal={this.guardarRegistro} />
            </Dialog>
            <Dialog appendTo={document.body} header="Actualizar Registro Patronal" visible={mostrarModalEditarRegistroPatronal}
                modal={true} onHide={this.cerrarModal} footer={pieDialogoDetalle}>
                <div className="p-grid">
                    <div className="p-col-3 p-md-3">
                        <label>* Registro Patronal:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.registroPatronal" name="registroPatronal.registroPatronal" placeholder="Registro Patronal" value={registroPatronal.registroPatronal || ""}
                            maxLength="11" keyfilter={DEFAULT_MASKS.alphanum} type="search" style={{ width: "100%" }} onChange={(e) => this.asignarValores(e, true)} />
                        {error.registroPatronal ? <div><Message severity="error" text={error.registroPatronal} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Representante Legal:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.representanteLegal" name="registroPatronal.representanteLegal" placeholder="Nombre" value={registroPatronal.representanteLegal || ""} maxLength="100" keyfilter={DEFAULT_MASKS.alphaspace} type="search" style={{ width: "100%" }} onChange={(e) => this.asignarValores(e, true)} />
                        {error.representanteLegal ? <div><Message severity="error" text={error.representanteLegal} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Actividad Económica:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.actividadEconomica" name="registroPatronal.actividadEconomica" placeholder="Actividad Económica" style={{ width: "100%" }}
                            value={registroPatronal.actividadEconomica || ""} onChange={(e) => { this.asignarValores(e, true) }} maxLength="100" keyfilter={DEFAULT_MASKS.alphaspace} type="search" />
                        {error.actividadEconomica ? <div><Message severity="error" text={error.actividadEconomica} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Calle No. y Colonia:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.calle" name="registroPatronal.calle" placeholder="Calle No. y Colonia" value={registroPatronal.calle || ""} type="search" maxLength="100" style={{ width: "100%" }} onChange={(e) => this.asignarValores(e, true)} />
                        {error.calle ? <div><Message severity="error" text={error.calle} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Código Postal:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.codigoPostal" name="registroPatronal.codigoPostal" placeholder="Código postal" style={{ width: "100%" }}
                            value={registroPatronal.codigoPostal || ""} className={error.codigoPostal ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="5" keyfilter="pint" type="search" />
                        {error.codigoPostal ? <div><Message severity="error" text={error.codigoPostal} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Entidad:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.entidad" name="registroPatronal.entidad" placeholder="Entidad" style={{ width: "100%", 'font-weight': 'bold', color: 'blue' }}
                            value={registroPatronal.entidad || ""} className={error.entidad ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            disabled={true} type="search" />
                        {error.entidad ? <div><Message severity="error" text={error.entidad} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Población y Municipio/Alcaldía:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <Dropdown id="registroPatronal.poblacion" name="registroPatronal.poblacion" optionLabel="label" options={municipios} value={registroPatronal.poblacion}
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.poblacion ? "p-error" : ""}
                            placeholder="Seleccione población" />
                        {error.poblacion ? <div><Message severity="error" text={error.poblacion} /></div> : null}
                    </div>

                    <div className="p-col-3 p-md-3">
                        <label>* Teléfono:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.telefono" name="registroPatronal.telefono" placeholder="Teléfono" style={{ width: "100%" }}
                            value={registroPatronal.telefono || ""} className={error.telefono ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            maxLength="10" keyfilter="pint" type="search" />
                        {error.telefono ? <div><Message severity="error" text={error.telefono} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Área Geográfica:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <Dropdown appendTo={document.body} id="registroPatronal.areaGeografica" name="registroPatronal.areaGeografica" options={areas}
                            placeholder="Área Geográfica" style={{ width: "100%" }} value={registroPatronal.areaGeografica}
                            onChange={(e) => this.asignarValores(e, false)} className={error.area ? "p-error" : ""} />
                        {error.area ? <div><Message severity="error" text={error.area} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Delegación IMSS:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <Dropdown appendTo={document.body} id="registroPatronal.delegacion" name="registroPatronal.delegacion" optionLabel="label" options={delegaciones} value={registroPatronal.delegacion}
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.delegacion ? "p-error" : ""}
                            placeholder="Delegación IMSS" />
                        {error.delegacion ? <div><Message severity="error" text={error.delegacion} /></div> : null}
                    </div>

                    <div className="p-col-3 p-md-3">
                        <label>* Clave Subdelegación:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <InputText id="registroPatronal.claveSubdelegacion" name="registroPatronal.claveSubdelegacion" placeholder="Clave Subdelegación" style={{ width: "100%", 'font-weight': 'bold', color: 'blue' }}
                            value={registroPatronal.claveSubdelegacion || ""} className={error.claveSubdelegacion ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }}
                            disabled={true} type="text" />
                        {error.claveSubdelegacion ? <div><Message severity="error" text={error.claveSubdelegacion} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <label>* Subdelegación IMSS:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <Dropdown appendTo={document.body} id="registroPatronal.subdelegacion" name="registroPatronal.subdelegacion" optionLabel="label" options={subdelegaciones} value={registroPatronal.subdelegacion}
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.subdelegacion ? "p-error" : ""}
                            placeholder="Subdelegación IMSS" />
                        {error.subdelegacion ? <div><Message severity="error" text={error.subdelegacion} /></div> : null}
                    </div>

                    <div className="p-col-3 p-md-3">
                        <label>* Mes y año de idsenube del Módulo de Afiliación:</label>
                    </div>
                    <div className="p-col-3 p-md-3">
                        <Dropdown appendTo={document.body} id="registroPatronal.mesAfiliacion" name="registroPatronal.mesAfiliacion" options={meses} placeholder="Mes" style={{ width: "100%" }} value={registroPatronal.mesAfiliacion} onChange={(e) => this.asignarValores(e, false)} className={error.mes ? "p-error" : ""} />
                        {error.mes ? <div><Message severity="error" text={error.mesAfiliacion} /></div> : null}
                    </div>
                    <div className="p-col-3 p-md-3">
                        <Dropdown appendTo={document.body} id="registroPatronal.anioAfiliacion" name="registroPatronal.anioAfiliacion" options={anios} placeholder="Año" style={{ width: "100%" }} value={registroPatronal.anioAfiliacion} onChange={(e) => this.asignarValores(e, false)} />
                        {error.anio ? <div><Message severity="error" text={error.anioAfiliacion} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-12">
                        <center><h1>Clase - Fracción - Prima de Riesgos de Trabajo</h1></center>
                    </div>

                    <div className="p-col-12 p-md-1">
                        <center><label>* Mes:</label></center>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <center><Dropdown appendTo={document.body} id="registroPatronal.meses" name="registroPatronal.meses" options={this.state.meses} placeholder="Mes" style={{ width: "100%" }} value={registroPatronal.meses}
                            onChange={(e) => this.asignarValores(e, false)} className={error.meses ? "p-error" : ""} /></center>
                        {error.meses ? <div><Message severity="error" text={error.meses} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* Año:</label></center>
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><Dropdown appendTo={document.body} id="registroPatronal.anios" name="registroPatronal.anios" options={this.state.anios} placeholder="Año" style={{ width: "100%" }} value={registroPatronal.anios}
                            onChange={(e) => this.asignarValores(e, false)} className={error.anios ? "p-error" : ""} /></center>
                        {error.anios ? <div><Message severity="error" text={error.anios} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* Prima:</label></center>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <center><InputText id="registroPatronal.prima" name="registroPatronal.prima" placeholder="0.00000" value={registroPatronal.prima || ""} maxLength="7" style={{ width: "100%" }}
                            onChange={(e) => this.asignarValores(e, true)} className={error.prima ? "p-error" : ""} keyfilter="num" min="0" step="0.50000" /></center>
                        {error.prima ? <div><Message severity="error" text={error.prima} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <center><Button id="registroPatronal.agregar" label="Agregar" icon="pi-md-plus" onClick={this.agregarPrimaRiesgoTrabajo} style={{ width: "100%" }} /></center>
                    </div>
                    {datosSeleccionados.length > 0 ?
                        <div className="p-col-12 p-md-2">
                            <center><Button label="Eliminar" icon="pi-md-delete" onClick={this.eliminarDelaListaCaptura} style={{ width: "100%" }} /></center>
                        </div> : ""}

                    <div className="p-col-12 p-md-12">
                        <label></label>
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label></label>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <DataTable value={listaPrimaRiesgo} responsive={true}>
                            <Column header="Seleccionar" body={this.plantillaChecBoxDatos} autoLayout={true} resizableColumns={true} />
                            <Column header="Mes" field="mes" autoLayout={true} resizableColumns={true} />
                            <Column header="Año" field="anio" autoLayout={true} resizableColumns={true} />
                            <Column header="Prima" field="prima" autoLayout={true} resizableColumns={true} />
                        </DataTable>
                    </div>
                    <div className="p-col-12 p-md-3">
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* Clase:</label></center>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <center><Dropdown id="registroPatronal.clase" name="registroPatronal.clase" optionValue="value" options={clases} value={registroPatronal.clase}
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.clase ? "p-error" : ""}
                            placeholder="Clase" /></center>
                        {error.clase ? <div><Message severity="error" text={error.clase} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* Fracción:</label></center>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <center><Dropdown id="registroPatronal.fraccion" name="registroPatronal.fraccion" optionValue="value" options={fracciones} value={registroPatronal.fraccion}
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.fraccion ? "p-error" : ""}
                            placeholder="Fracción" /></center>
                        {error.fraccion ? <div><Message severity="error" text={error.fraccion} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* STyPS:</label></center>
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><Dropdown id="registroPatronal.styps" name="registroPatronal.styps" options={stypss} placeholder="STyPS" style={{ width: "100%" }} value={registroPatronal.styps} onChange={(e) => this.asignarValores(e, false)} /></center>
                        {error.styps ? <div><Message severity="error" text={error.styps} /></div> : null}
                    </div>

                </div>
            </Dialog>

            <Dialog visible={this.state.mostrarModalCertificados}
                header="Carga de certificado"
                modal={true} footer={pieDialogoCertificado}
                onHide={this.resetEstados.bind(this)}>
                <h4>Los campos con (*) son obligatorios, por favor captura los datos de la Empresa</h4>

                <div className="p-grid form-group">
                    <div className="p-col-12 p-md-12" >
                        <Dropdown appendTo={document.body} id="opcion.valor" name="opcion.valor" optionLabel="label" options={opcionCertificados} value={opcion.valor}
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={errores.opcion ? "p-error" : ""}
                            placeholder="Seleccione tipo certificado" />
                        {errores.opcion ? <div><Message severity="error" text={errores.opcion} /></div> : null}
                    </div>
                    {esPfx || esFiel ?
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="registroPatronal.usuario" name="registroPatronal.usuario" value={registroPatronal.usuario || ""} className={erroresCarga.usuario ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "90%" }} />
                                <label>* Usuario Idse:</label>
                                {erroresCarga.usuario ? <div><Message severity="error" text={erroresCarga.usuario} /> </div> : null}
                            </span>
                        </div>
                        : null}
                    {esPfx ?
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="password" maxLength="200" id="registroPatronal.contraseniaPfx" name="registroPatronal.contraseniaPfx" value={registroPatronal.contraseniaPfx || ""} className={erroresCarga.contrasena ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "90%" }} />
                                <label>* Contraseña:</label>
                                {erroresCarga.contrasena ? <div><Message severity="error" text={erroresCarga.contrasena} /> </div> : null}
                            </span>
                        </div>
                        : null}
                    {esFiel ?
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="password" maxLength="200" id="registroPatronal.contraseniaFiel" name="registroPatronal.contraseniaFiel" value={registroPatronal.contraseniaFiel || ""} className={erroresCarga.contraseniaFiel ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "90%" }} />
                                <label>* Contraseña:</label>
                                {erroresCarga.contraseniaFiel ? <div><Message severity="error" text={erroresCarga.contraseniaFiel} /> </div> : null}
                            </span>
                        </div>
                        : null}
                    {esPfx ?
                        <div className="p-col-12 p-md-12">
                            <div className="p-col-12 p-md-6">
                                <FileUpload
                                    id="archivoPfx"
                                    name="demo"
                                    chooseLabel="Subir archivo pfx"
                                    uploadHandler={this.onUpload}
                                    auto="true" customUpload
                                    accept=".pfx"
                                    mode="basic">

                                </FileUpload>
                                {erroresCarga.certificadoPfx ? (<div> <br /> <Message severity="error" text={erroresCarga.certificadoPfx} />{" "} </div>) : null}

                            </div>

                        </div>
                        : null}
                    {esFiel ?
                        <div className="p-col-12 p-md-6">
                            <Archivo id="archivo_cer" etiqueta="Cargar archivo .cer" nombre="registroPatronal.certificadoCer" cambio={this.cargarArchivo} aceptar=".cer" />
                            {erroresCarga.certificadoCer ? <div><br /> <Message severity="error" text={erroresCarga.certificadoCer} /> </div> : null}
                        </div>
                        : null}
                    {esFiel ?
                        <div className="p-col-12 p-md-6">
                            <Archivo id="archivo_key" etiqueta="Cargar archivo .key" nombre="registroPatronal.certificadoKey" cambio={this.cargarArchivo} aceptar=".key" />
                            {erroresCarga.certificadoKey ? <div><br /> <Message severity="error" text={erroresCarga.certificadoKey} /> </div> : null}
                        </div>
                        : null}
                </div>
            </Dialog>
            <Dialog
                header="Confirmación"
                visible={mostrarModalConfirmacionRegistro}
                modal={true}
                appendTo={document.body}
                footer={dialogFooterConfirmacionEliminarRegistroPatronal}
                onHide={this.resetEstados}>
                <h2>¿Estás seguro de eliminar el registro patronal?</h2>
            </Dialog>
        </div>);
    }
}